import { render, staticRenderFns } from "./Convenio.vue?vue&type=template&id=6d073727&scoped=true&"
import script from "./Convenio.vue?vue&type=script&lang=js&"
export * from "./Convenio.vue?vue&type=script&lang=js&"
import style0 from "./Convenio.vue?vue&type=style&index=0&id=6d073727&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d073727",
  null
  
)

export default component.exports